export default __webpack_public_path__ + "static/pages_partner_creative-5a9470c019b7563dd8650c2f38029a01.svg";